module.exports = __webpack_public_path__ + "img/info-white.54001530.svg";